export function mockTmbCard() {
	return {
		data: {
			id: "holabarcelona-travel-card",
			"catalogue-items": [
				{
					contextType: "BOOKEE_CONTEXT",
					contextValue:
						'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"113"}',
					provider: "tmb",
					name: "Hola Barcelona Travel Card 2 Días (48h)",
					description: {
						details: [
							{
								title: "descripción",
								body: "Con el abono Hola Barcelona Travel Card, dispones de viajes ilimitados en el transporte publico de Barcelona durante 2 Días (48 h) consecutivos desde la primera validación y a cualquier hora del día",
							},
							{
								title: "Incluye",
								body: "La tarjeta Hola Barcelona Travel Card es un título unipersonal que te permite utilizar tantas veces como desees el metro y el bus (TMB), ferrocarril (FGC, zona 1), funicular de Montjuïc, tranvía (TRAM) y trenes de cercanías Cercanías de Cataluña (zona 1). Teleférico de Montjuïc no incluido. Hola Barcelona Travel Card incluye el desplazamiento de ida y vuelta en Metro (TMB) desde el aeropuerto al centro de Barcelona. No pagas suplementos por el traslado y disfruta de tu Hola Barcelona Travel Card desde el primer minuto.",
							},
							{
								title: "Como-funciona",
								body: "Te enviaremos un voucher por correo electrónico con un código personalizado. Podrás canjear tu abono con este código en cualquier estación de Metro. Solo Hola Barcelona te ofrece este servicio. Ahórrate así los gastos de envío y las colas.",
							},
							{
								title: "Política-de-cancelación",
								body: "Reserva válida durante 90 días naturales desde la fecha de compra y, como máximo, hasta el último día de febrero del año siguiente.",
							},
						],
					},
					url: "https://www.holabarcelona.com/es/tickets/hola-bcn-barcelona-travel-card",
					price: {
						gross: 1476,
						taxes: 0,
						includedTaxes: 0,
						currency: "EUR",
					},
				},
				{
					contextType: "BOOKEE_CONTEXT",
					contextValue:
						'psm|bookee|0.1|GZPUtSaWIml7o/sdvKZY4A==|{"productCode":"010"}',
					provider: "psm",
					name: "Hola Barcelona Travel Card 3 Días (72h)",
					description: {
						details: [
							{
								title: "descripción",
								body: "Con el abono Hola Barcelona Travel Card, dispones de viajes ilimitados en el transporte publico de Barcelona durante 3 Días (72 h) consecutivos desde la primera validación y a cualquier hora del día",
							},
							{
								title: "Incluye",
								body: "La tarjeta Hola Barcelona Travel Card es un título unipersonal que te permite utilizar tantas veces como desees el metro y el bus (TMB), ferrocarril (FGC, zona 1), funicular de Montjuïc, tranvía (TRAM) y trenes de cercanías Cercanías de Cataluña (zona 1). Teleférico de Montjuïc no incluido. Hola Barcelona Travel Card incluye el desplazamiento de ida y vuelta en Metro (TMB) desde el aeropuerto al centro de Barcelona. No pagas suplementos por el traslado y disfruta de tu Hola Barcelona Travel Card desde el primer minuto.",
							},
							{
								title: "Como-funciona",
								body: "Te enviaremos un voucher por correo electrónico con un código personalizado. Podrás canjear tu abono con este código en cualquier estación de Metro. Solo Hola Barcelona te ofrece este servicio. Ahórrate así los gastos de envío y las colas.",
							},
							{
								title: "Política-de-cancelación",
								body: "Reserva válida durante 90 días naturales desde la fecha de compra y, como máximo, hasta el último día de febrero del año siguiente.",
							},
						],
					},
					url: "https://www.holabarcelona.com/es/tickets/hola-bcn-barcelona-travel-card",
					price: {
						gross: 2142,
						taxes: 0,
						includedTaxes: 0,
						currency: "EUR",
					},
				},
				{
					contextType: "BOOKEE_CONTEXT",
					contextValue:
						'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"113"}',
					provider: "tmb",
					name: "Hola Barcelona Travel Card 4 Días (96h)",
					description: {
						details: [
							{
								title: "descripción",
								body: "Con el abono Hola Barcelona Travel Card, dispones de viajes ilimitados en el transporte publico de Barcelona durante 4 Días (96 h) consecutivos desde la primera validación y a cualquier hora del día",
							},
							{
								title: "Incluye",
								body: "La tarjeta Hola Barcelona Travel Card es un título unipersonal que te permite utilizar tantas veces como desees el metro y el bus (TMB), ferrocarril (FGC, zona 1), funicular de Montjuïc, tranvía (TRAM) y trenes de cercanías Cercanías de Cataluña (zona 1). Teleférico de Montjuïc no incluido. Hola Barcelona Travel Card incluye el desplazamiento de ida y vuelta en Metro (TMB) desde el aeropuerto al centro de Barcelona. No pagas suplementos por el traslado y disfruta de tu Hola Barcelona Travel Card desde el primer minuto.",
							},
							{
								title: "Como-funciona",
								body: "Te enviaremos un voucher por correo electrónico con un código personalizado. Podrás canjear tu abono con este código en cualquier estación de Metro. Solo Hola Barcelona te ofrece este servicio. Ahórrate así los gastos de envío y las colas.",
							},
							{
								title: "Política-de-cancelación",
								body: "Reserva válida durante 90 días naturales desde la fecha de compra y, como máximo, hasta el último día de febrero del año siguiente.",
							},
						],
					},
					url: "https://www.holabarcelona.com/es/tickets/hola-bcn-barcelona-travel-card",
					price: {
						gross: 2790,
						taxes: 0,
						includedTaxes: 0,
						currency: "EUR",
					},
				},
				{
					contextType: "BOOKEE_CONTEXT",
					contextValue:
						'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"113"}',
					provider: "tmb",
					name: "Hola Barcelona Travel Card 5 Días (120h)",
					description: {
						details: [
							{
								title: "descripción",
								body: "Con el abono Hola Barcelona Travel Card, dispones de viajes ilimitados en el transporte publico de Barcelona durante 5 Días (120 h) consecutivos desde la primera validación y a cualquier hora del día",
							},
							{
								title: "Incluye",
								body: "La tarjeta Hola Barcelona Travel Card es un título unipersonal que te permite utilizar tantas veces como desees el metro y el bus (TMB), ferrocarril (FGC, zona 1), funicular de Montjuïc, tranvía (TRAM) y trenes de cercanías Cercanías de Cataluña (zona 1). Teleférico de Montjuïc no incluido. Hola Barcelona Travel Card incluye el desplazamiento de ida y vuelta en Metro (TMB) desde el aeropuerto al centro de Barcelona. No pagas suplementos por el traslado y disfruta de tu Hola Barcelona Travel Card desde el primer minuto.",
							},
							{
								title: "Como-funciona",
								body: "Te enviaremos un voucher por correo electrónico con un código personalizado. Podrás canjear tu abono con este código en cualquier estación de Metro. Solo Hola Barcelona te ofrece este servicio. Ahórrate así los gastos de envío y las colas.",
							},
							{
								title: "Política-de-cancelación",
								body: "Reserva válida durante 90 días naturales desde la fecha de compra y, como máximo, hasta el último día de febrero del año siguiente.",
							},
						],
					},
					url: "https://www.holabarcelona.com/es/tickets/hola-bcn-barcelona-travel-card",
					price: {
						gross: 3438,
						taxes: 0,
						includedTaxes: 0,
						currency: "EUR",
					},
				},
			],
		},
		
	};
}

export function mockTmbHolabarcelona() {
	return {
		data: {
			id: "holabarcelona-travel-card",
			"catalogue-items": [
				{
					contextType: "BOOKEE_CONTEXT",
					contextValue:
						'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"113"}',
					provider: "tmb",
					name: "Hola Barcelona Travel Card 2 Días (48h)",
					description: {
						details: [
							{
								title: "Descripción",
								body: "Con el abono Hola Barcelona Travel Card, dispones de viajes ilimitados en el transporte publico de Barcelona durante 2 Días (48 h) consecutivos desde la primera validación y a cualquier hora del día",
							},
							{
								title: "Incluye",
								body: "La tarjeta Hola Barcelona Travel Card es un título unipersonal que te permite utilizar tantas veces como desees el metro y el bus (TMB), ferrocarril (FGC, zona 1), funicular de Montjuïc, tranvía (TRAM) y trenes de cercanías Cercanías de Cataluña (zona 1). Teleférico de Montjuïc no incluido. Hola Barcelona Travel Card incluye el desplazamiento de ida y vuelta en Metro (TMB) desde el aeropuerto al centro de Barcelona. No pagas suplementos por el traslado y disfruta de tu Hola Barcelona Travel Card desde el primer minuto.",
							},
							{
								title: "Como funciona",
								body: "Te enviaremos un voucher por correo electrónico con un código personalizado. Podrás canjear tu abono con este código en cualquier estación de Metro. Solo Hola Barcelona te ofrece este servicio. Ahórrate así los gastos de envío y las colas.",
							},
							{
								title: "Política de cancelación",
								body: "Reserva válida durante 90 días naturales desde la fecha de compra y, como máximo, hasta el último día de febrero del año siguiente.",
							},
						],
					},
					url: "https://www.holabarcelona.com/es/tickets/hola-bcn-barcelona-travel-card",
					price: [
						{
							type: "Adultos",
							contextValue:
								'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"095","tripCode":"BCN_NIGHT_TOUR_20230603_V_2"}',
							gross: 1476,
							currency: "EUR",
						},
						{
							type: "Infantiles",
							contextValue:
								'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"096","tripCode":"BCN_NIGHT_TOUR_20230603_V_2"}',
							gross: 1000,
							currency: "EUR",
						},
						{
							type: "Senior/Discpacitado",
							contextValue:
								'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"118","tripCode":"BCN_NIGHT_TOUR_20230603_V_2"}',
							gross: 0,
							currency: "EUR",
						},
						{
							type: "Niño Menores de 4 años",
							contextValue:
								'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"118","tripCode":"BCN_NIGHT_TOUR_20230603_V_2"}',
							gross: 0,
							currency: "EUR",
						},
					],
				},
				{
					contextType: "BOOKEE_CONTEXT",
					contextValue:
						'psm|bookee|0.1|GZPUtSaWIml7o/sdvKZY4A==|{"productCode":"010"}',
					provider: "psm",
					name: "Hola Barcelona Travel Card 3 Días (72h)",
					description: {
						details: [
							{
								title: "Descripción",
								body: "Con el abono Hola Barcelona Travel Card, dispones de viajes ilimitados en el transporte publico de Barcelona durante 3 Días (72 h) consecutivos desde la primera validación y a cualquier hora del día",
							},
							{
								title: "Incluye",
								body: "La tarjeta Hola Barcelona Travel Card es un título unipersonal que te permite utilizar tantas veces como desees el metro y el bus (TMB), ferrocarril (FGC, zona 1), funicular de Montjuïc, tranvía (TRAM) y trenes de cercanías Cercanías de Cataluña (zona 1). Teleférico de Montjuïc no incluido. Hola Barcelona Travel Card incluye el desplazamiento de ida y vuelta en Metro (TMB) desde el aeropuerto al centro de Barcelona. No pagas suplementos por el traslado y disfruta de tu Hola Barcelona Travel Card desde el primer minuto.",
							},
							{
								title: "Como funciona",
								body: "Te enviaremos un voucher por correo electrónico con un código personalizado. Podrás canjear tu abono con este código en cualquier estación de Metro. Solo Hola Barcelona te ofrece este servicio. Ahórrate así los gastos de envío y las colas.",
							},
							{
								title: "Política de cancelación",
								body: "Reserva válida durante 90 días naturales desde la fecha de compra y, como máximo, hasta el último día de febrero del año siguiente.",
							},
						],
					},
					url: "https://www.holabarcelona.com/es/tickets/hola-bcn-barcelona-travel-card",
					price: [
						{
							type: "Adultos",
							contextValue:
								'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"095","tripCode":"BCN_NIGHT_TOUR_20230603_V_2"}',
							gross: 2142,
							currency: "EUR",
						},
						{
							type: "Infantiles",
							contextValue:
								'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"096","tripCode":"BCN_NIGHT_TOUR_20230603_V_2"}',
							gross: 1000,
							currency: "EUR",
						},
						{
							type: "Senior/Discpacitado",
							contextValue:
								'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"118","tripCode":"BCN_NIGHT_TOUR_20230603_V_2"}',
							gross: 0,
							currency: "EUR",
						},
						{
							type: "Niño Menores de 4 años",
							contextValue:
								'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"118","tripCode":"BCN_NIGHT_TOUR_20230603_V_2"}',
							gross: 0,
							currency: "EUR",
						},
					],
				},
				{
					contextType: "BOOKEE_CONTEXT",
					contextValue:
						'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"113"}',
					provider: "tmb",
					name: "Hola Barcelona Travel Card 4 Días (96h)",
					description: {
						details: [
							{
								title: "Descripción",
								body: "Con el abono Hola Barcelona Travel Card, dispones de viajes ilimitados en el transporte publico de Barcelona durante 4 Días (96 h) consecutivos desde la primera validación y a cualquier hora del día",
							},
							{
								title: "Incluye",
								body: "La tarjeta Hola Barcelona Travel Card es un título unipersonal que te permite utilizar tantas veces como desees el metro y el bus (TMB), ferrocarril (FGC, zona 1), funicular de Montjuïc, tranvía (TRAM) y trenes de cercanías Cercanías de Cataluña (zona 1). Teleférico de Montjuïc no incluido. Hola Barcelona Travel Card incluye el desplazamiento de ida y vuelta en Metro (TMB) desde el aeropuerto al centro de Barcelona. No pagas suplementos por el traslado y disfruta de tu Hola Barcelona Travel Card desde el primer minuto.",
							},
							{
								title: "Como funciona",
								body: "Te enviaremos un voucher por correo electrónico con un código personalizado. Podrás canjear tu abono con este código en cualquier estación de Metro. Solo Hola Barcelona te ofrece este servicio. Ahórrate así los gastos de envío y las colas.",
							},
							{
								title: "Política de cancelación",
								body: "Reserva válida durante 90 días naturales desde la fecha de compra y, como máximo, hasta el último día de febrero del año siguiente.",
							},
						],
					},
					url: "https://www.holabarcelona.com/es/tickets/hola-bcn-barcelona-travel-card",
					price: [
						{
							type: "Adultos",
							contextValue:
								'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"095","tripCode":"BCN_NIGHT_TOUR_20230603_V_2"}',
							gross: 2790,
							currency: "EUR",
						},
						{
							type: "Infantiles",
							contextValue:
								'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"096","tripCode":"BCN_NIGHT_TOUR_20230603_V_2"}',
							gross: 1000,
							currency: "EUR",
						},
						{
							type: "Senior/Discpacitado",
							contextValue:
								'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"118","tripCode":"BCN_NIGHT_TOUR_20230603_V_2"}',
							gross: 0,
							currency: "EUR",
						},
						{
							type: "Niño Menores de 4 años",
							contextValue:
								'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"118","tripCode":"BCN_NIGHT_TOUR_20230603_V_2"}',
							gross: 0,
							currency: "EUR",
						},
					],
				},
				{
					contextType: "BOOKEE_CONTEXT",
					contextValue:
						'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"113"}',
					provider: "tmb",
					name: "Hola Barcelona Travel Card 5 Días (120h)",
					description: {
						details: [
							{
								title: "Descripción",
								body: "Con el abono Hola Barcelona Travel Card, dispones de viajes ilimitados en el transporte publico de Barcelona durante 5 Días (120 h) consecutivos desde la primera validación y a cualquier hora del día",
							},
							{
								title: "Incluye",
								body: "La tarjeta Hola Barcelona Travel Card es un título unipersonal que te permite utilizar tantas veces como desees el metro y el bus (TMB), ferrocarril (FGC, zona 1), funicular de Montjuïc, tranvía (TRAM) y trenes de cercanías Cercanías de Cataluña (zona 1). Teleférico de Montjuïc no incluido. Hola Barcelona Travel Card incluye el desplazamiento de ida y vuelta en Metro (TMB) desde el aeropuerto al centro de Barcelona. No pagas suplementos por el traslado y disfruta de tu Hola Barcelona Travel Card desde el primer minuto.",
							},
							{
								title: "Como funciona",
								body: "Te enviaremos un voucher por correo electrónico con un código personalizado. Podrás canjear tu abono con este código en cualquier estación de Metro. Solo Hola Barcelona te ofrece este servicio. Ahórrate así los gastos de envío y las colas.",
							},
							{
								title: "Política de cancelación",
								body: "Reserva válida durante 90 días naturales desde la fecha de compra y, como máximo, hasta el último día de febrero del año siguiente.",
							},
						],
					},
					url: "https://www.holabarcelona.com/es/tickets/hola-bcn-barcelona-travel-card",
					price: [
						{
							type: "Adultos",
							contextValue:
								'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"095","tripCode":"BCN_NIGHT_TOUR_20230603_V_2"}',
							gross: 3438,
							currency: "EUR",
						},
						{
							type: "Infantiles",
							contextValue:
								'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"096","tripCode":"BCN_NIGHT_TOUR_20230603_V_2"}',
							gross: 1000,
							currency: "EUR",
						},
						{
							type: "Senior/Discpacitado",
							contextValue:
								'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"118","tripCode":"BCN_NIGHT_TOUR_20230603_V_2"}',
							gross: 0,
							currency: "EUR",
						},
						{
							type: "Niño Menores de 4 años",
							contextValue:
								'tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{"productCode":"118","tripCode":"BCN_NIGHT_TOUR_20230603_V_2"}',
							gross: 0,
							currency: "EUR",
						},
					],
				},
			],
		},
	};
}

export function mockTmbNightBus() {
  return {
	"data": {
		"id": "barcelona-night-bus-id",
		"catalogue-items": [
		  {
			"contextType": "BOOKEE_CONTEXT",
			"provider": "tmb",
			"name": "Barcelona Night Tour Bus Inglés",
			"description": {
			  "details": [
				{
				  "title": "Descripción",
				  "body": "Una ruta nocturna guiada para disfrutar de las nochesmediterráneas del verano de Barcelona. La magia de la noche le descubrirá unaciudad diferente, llena de calidez, de sombras y de luces especiales.\r\n\r\nBarcelona se ilumina con una luz especial durante las noches de verano. Cuando se esconde el sol y baja el calor, la ciudad se hace irresistible. Es el mejor momento para pasear tranquilamente, descubrir secretos y lugares especiales y contemplar la arquitectura modernista desde un punto de vista diferente.\r\n\r\nDías de servicio: de lunes a domingo.\r\nHorario de salida: 21.30 horas. Escoge el idioma de tu ruta en castellano, inglés o bilingüe catalán/castellano.\r\nPunto de salida: plaza Catalunya (Barcelona).\r\nDuración aproximada de la ruta: 1 h 15 min - 1 h 30 min."
				},
				{
				  "title": "Incluye",
				  "body": "Visita guiada en castellano, inglés o bilingüe catalán/castellano. Autobús de doble piso descubierto. Atención personalizada: es el único bus turístico con informadores oficiales de Turismo de Barcelona a bordo. Acceso wifi gratuito, con conexión directa, para estar en línea durante todo el recorrido. Servicio adaptado para personas con movilidad reducida y con pérdida auditiva."
				},
				{
				  "title": "Cómo funciona",
				  "body": "Reserva en línea y muestra el voucher a través de tu dispositivo móvil o impreso en papel al guía a bordo del bus.\r\nPresentación en el punto de encuentro: 20 minutos antes de la salida."
				},
				{
				  "title": "Política de cancelación",
				  "body": "Reserva válida durante 90 días naturales desde la fecha de la compra."
				}
			  ]
			},
			"image": "https://pro.static.holabarcelona.com/images/1587/resize/296/526/5.jpg",
			"price": [
			  {
				"isAdult": true,
				"type": "Adultos",
				"contextValue": "tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{\"productCode\":\"095\",\"tripCode\":\"BCN_NIGHT_TOUR_20230603_V_2\"}",
				"gross": 2200,
				"currency": "EUR"
			  },
			  {
				"isAdult": false,
				"type": "infantiles",
				"contextValue": "tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{\"productCode\":\"096\",\"tripCode\":\"BCN_NIGHT_TOUR_20230603_V_2\"}",
				"gross": 1000,
				"currency": "EUR"
			  },
			  {
				"isAdult": false,
				"type": "Menores de 4 años",
				"contextValue": "tmb|bookee|0.1|TG77r9/lRNAt2YTeNhdx9A==|{\"productCode\":\"118\",\"tripCode\":\"BCN_NIGHT_TOUR_20230603_V_2\"}",
				"gross": 0,
				"currency": "EUR"
			  }
			],
			"availability": [
			  {
				"totalAvailability": 6,
				"language": ["es"],
				"serviceDate": "2024-03-20T10:30:00Z"
			  },
			  {
				"totalAvailability": 4,
				"language": ["en"],
				"serviceDate": "2024-03-20T09:30:00Z"
			  },
			  {
				"totalAvailability": 10,
				"language": [, "es",],
				"serviceDate": "2024-03-20T12:30:00Z"
			  },
			  {
				"totalAvailability": 0,
				"language": ["ca", "es",],
				"serviceDate": "2024-03-20T19:00:00Z"
			  }
			]
		  }
		],
		"privacy": "https://www.docomobility.com/es/ayuda",
		"cancelation": "https://www.docomobility.com/es/acerca-de-doco"
	  }
	};
}